import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Row, Col, Label} from 'reactstrap';
import LoadingImage from "../../../comum/components/LoadingImage";
import Checkbox from '../../../comum/components/Checkbox'
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import {IconeDelete} from "../../../comum/components/Icones";
import FormInputSimples from "../../../comum/components/FormInputSimples";
import {buscaSemResultado} from "../../../../utils/mensagens";
import CheckboxArea from "../../../comum/components/CheckboxArea";

@inject("store")
@observer
export class AreaSelecaoContainers extends Component{

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controllerCadastrar = this.props.controller;
    };

    alertaVolume = (cntr) => {
        return (this.controllerCadastrar.salvo
            && (this.controllerCadastrar.parametrosDeCampos.inputVolume || this.controllerCadastrar.dadosDoServico.AgendServ.FlgComboio==='S')
            && (cntr.Volumes===null || cntr.Volumes===0 || cntr.Volumes.length===0))
                ? this.controllerCadastrar.msgObrigatorio : false;
    };

    // Tabela
    headerTableSelecaoContainer = (sizeColumn) => {
        return <Row className="header-row">
            <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                <Checkbox onClick={ () => this.controllerCadastrar.marcarTodosContainer() } 
                          ativo={ this.controllerCadastrar.todosContainersMarcados } 
                          bloqueado={this.props.bloqueado}
                />
            </Col>
            <Col xs={sizeColumn} sm={sizeColumn} md={sizeColumn} lg={sizeColumn} xl={sizeColumn}>
                <Label className="header-label">
                    Containers
                </Label>
            </Col>
            { this.controllerCadastrar.parametrosDeCampos.selectNotas &&
            <Col xs={4} sm={4} md={4} lg={4} xl={4} className="col-notaFiscal">
                <Label className="header-label">
                    Notas fiscais
                </Label>
            </Col> }
            { (this.controllerCadastrar.parametrosDeCampos.inputVolume || this.controllerCadastrar.dadosDoServico.AgendServ.FlgComboio==='S') &&
            <Col xs={sizeColumn} sm={sizeColumn} md={sizeColumn} lg={sizeColumn} xl={sizeColumn}>
                <Label className="header-label">
                    Volume
                </Label>
            </Col> }
        </Row>;
    };

    dataTableSelecaoContainer = (sizeColumn) => {
        return this.controllerCadastrar.containers.map((cntr, index) =>
            <Row key={cntr.CodCntr} className="row-lista formulario">
                <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                    <Checkbox onClick={ () => this.controllerCadastrar.marcarContainer(cntr) } 
                              ativo={cntr.marcado}
                              bloqueado={this.props.bloqueado}
                    />
                </Col>
                <Col xs={sizeColumn} sm={sizeColumn} md={sizeColumn} lg={sizeColumn} xl={sizeColumn}>
                    <Label>
                        {cntr.CodCntr}
                    </Label>
                </Col>
                { this.controllerCadastrar.parametrosDeCampos.selectNotas && cntr.marcado
                    && this.campoNotasFiscais(cntr, 4, 4, 4, 4, 4 ) }
                { (this.controllerCadastrar.parametrosDeCampos.inputVolume || this.controllerCadastrar.dadosDoServico.AgendServ.FlgComboio==='S') && cntr.marcado
                    && <Col xs={sizeColumn} sm={sizeColumn} md={sizeColumn} lg={sizeColumn} xl={sizeColumn}>
                        <FormInputSimples type="number"
                                          dado={cntr.Volumes}
                                          onChange={ (event) => this.controllerCadastrar.onChangeVolume(event, index) }
                                          alerta={ this.alertaVolume(cntr, index) }
                                          bloqueado={this.props.bloqueado}
                        />
                </Col> }
            </Row>)
    };
    // FIM Tabela

    // Lista de cards
    listaCards = () => {
        return this.controllerCadastrar.containers.map((cntr, index) =>
            <Row key={cntr.CodCntr} className="card-detalhe formulario">
                <CheckboxArea xs={12} sm={12} md={12} lg={12} xl={12}
                              mensagem={ <Label className="label-disabled">{ cntr.CodCntr }</Label> }
                              checked={ cntr.marcado }
                              onClick={ () => this.controllerCadastrar.marcarContainer(cntr) } 
                              bloqueado={this.props.bloqueado}
                />
                { this.controllerCadastrar.parametrosDeCampos.inputVolume
                    && <Col xs={12} sm={6} md={6} lg={6} xl={6} >
                        <FormInputSimples titulo="Volume" type="number"
                                          onChange={ (event) => this.controllerCadastrar.onChangeVolume(event, index) }
                                          bloqueado={this.props.bloqueado}
                                          alerta={ this.alertaVolume(cntr, index)}
                        />
                    </Col> }
                { this.controllerCadastrar.parametrosDeCampos.selectNotas
                    && this.campoNotasFiscais(cntr, 12, 6, 6, 6, 6, "Notas fiscais") }
            </Row>)
    };
    // FIM Lista de cards

    campoNotasFiscais = (row, xs, sm, md, lg, xl, titulo=false) => {
        return <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} >
                <FormSelectSimples titulo={titulo}
                                   itens={ row.notasContainer }
                                   dado={null}
                                   bloqueado={!this.props.bloqueado ? !row.notasContainer : true}
                                   alerta={ this.controllerCadastrar.salvo && this.controllerCadastrar.parametrosDeCampos.camposObrigatorios.selectNotas && (!row.NotasFiscais || row.NotasFiscais.length===0) ? "Campo obrigatório" : false }
                                   onChange={ (event) => this.controllerCadastrar.onChangeNotaFiscalSelecaoContainer(row, event) } />
                { row.NotasFiscais
                    && row.NotasFiscais.map((notaFiscal, index) =>
                        <Row key={index} >
                            <Col xl={8} lg={8} md={8} sm={8} xs={8} className="row-notaFiscal-adicionada">
                                <Label>{ notaFiscal.label }</Label>
                            </Col>
                            <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                                <IconeDelete tamanho="lg" onClick={ () => this.controllerCadastrar.removeNotaFiscalFromSelecaoContainer(row, notaFiscal, index) }/>
                            </Col>
                        </Row>) }
            </Col>;
    };

    tabela = (sizeColumn) => {
        if (!this.controllerCadastrar.salvando)
        {
            if (!this.appStore.isMobile()) {
                return <React.Fragment>
                        { this.headerTableSelecaoContainer(sizeColumn) }
                        { this.dataTableSelecaoContainer(sizeColumn) }
                    </React.Fragment>
            } else {
                return this.listaCards();
            }
        }        
    };

    render() {
        const sizeColumn = this.controllerCadastrar.parametrosDeCampos.selectNotas ? 3 : 4;
        return <div className="area-selecao-container">
                { (!(this.controllerCadastrar.blSelecionado || this.controllerCadastrar.parametrosDeCampos.pesagemContainersExportacao) && !this.controllerCadastrar.isEditar)
                    ? <Row>
                        <Col xs={12}>
                            <span className="mensagem-filtrar">
                                Selecione BL ou Booking para buscar containers
                            </span>
                        </Col>
                    </Row>
                    : <div className="tabela-home-made">
                        { this.controllerCadastrar.loadingContainers ? <LoadingImage />
                            : <React.Fragment>
                                { (!this.controllerCadastrar.containers || this.controllerCadastrar.containers.length===0)
                                    ? <Row>
                                        <Col xs={12}>
                                            <span className="mensagem-filtrar">
                                                { buscaSemResultado }
                                            </span>
                                        </Col>
                                    </Row>
                                    : <React.Fragment>
                                        { this.tabela(sizeColumn) }
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </div>
                }
            </div>;
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamentoservicosTotal/cadastrar/components/AreaSelecaoContainers.js